<script setup lang="ts">
  import IconBase from './IconBase.vue'

  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 36,
      height: 36,
      color: 'currentColor',
      viewBoxValue: `-2 -2 40 40`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <path
      d="M22.5 15C23.39 15 24.26 14.7361 25.0001 14.2416C25.7401 13.7471 26.3169 13.0443 26.6575 12.2221C26.9981 11.3998 27.0872 10.495 26.9135 9.62209C26.7399 8.74918 26.3113 7.94736 25.682 7.31802C25.0526 6.68868 24.2508 6.2601 23.3779 6.08647C22.505 5.91283 21.6002 6.00195 20.7779 6.34254C19.9557 6.68314 19.2529 7.25991 18.7584 7.99993C18.2639 8.73995 18 9.60998 18 10.5C18 11.6935 18.4741 12.8381 19.318 13.682C20.1619 14.5259 21.3065 15 22.5 15ZM22.5 9C22.7967 9 23.0867 9.08797 23.3334 9.2528C23.58 9.41762 23.7723 9.65189 23.8858 9.92597C23.9993 10.2001 24.0291 10.5017 23.9712 10.7926C23.9133 11.0836 23.7704 11.3509 23.5607 11.5607C23.3509 11.7704 23.0836 11.9133 22.7926 11.9712C22.5017 12.0291 22.2001 11.9994 21.926 11.8858C21.6519 11.7723 21.4176 11.58 21.2528 11.3334C21.088 11.0867 21 10.7967 21 10.5C21 10.1022 21.158 9.72064 21.4393 9.43934C21.7206 9.15804 22.1022 9 22.5 9Z"
      fill="currentColor"
    />
    <path
      d="M33 0H3C2.20435 0 1.44129 0.31607 0.87868 0.87868C0.31607 1.44129 0 2.20435 0 3V33C0 33.7957 0.31607 34.5587 0.87868 35.1213C1.44129 35.6839 2.20435 36 3 36H33C33.7957 36 34.5587 35.6839 35.1213 35.1213C35.6839 34.5587 36 33.7957 36 33V3C36 2.20435 35.6839 1.44129 35.1213 0.87868C34.5587 0.31607 33.7957 0 33 0ZM33 33H3V24L10.5 16.5L18.885 24.885C19.4471 25.4438 20.2074 25.7574 21 25.7574C21.7926 25.7574 22.5529 25.4438 23.115 24.885L25.5 22.5L33 30V33ZM33 25.755L27.615 20.37C27.0529 19.8112 26.2926 19.4976 25.5 19.4976C24.7074 19.4976 23.9471 19.8112 23.385 20.37L21 22.755L12.615 14.37C12.0529 13.8112 11.2926 13.4976 10.5 13.4976C9.70744 13.4976 8.94709 13.8112 8.385 14.37L3 19.755V3H33V25.755Z"
      fill="currentColor"
    />
  </IconBase>
</template>

<style scoped lang="scss"></style>
